import { render, staticRenderFns } from "./FileInfoTab.vue?vue&type=template&id=834808e2&scoped=true&"
import script from "./FileInfoTab.vue?vue&type=script&lang=js&"
export * from "./FileInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./FileInfoTab.vue?vue&type=style&index=0&id=834808e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834808e2",
  null
  
)

export default component.exports